module.exports = __webpack_public_path__ + "img/tab3@2x.af9f8f08.png";